import { connect } from 'react-redux'
import ProviderTripsTable from '../../components/trips/management/ProviderTripsTable'
import { actionCreators, getManyTrips, getTripsSummary } from '../../state/actions/trips/index'
import { IStoreState, IPagination, ITripFilters, ITripState, ITripSummaryFiltersDTO } from '../../types'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  const orgId = state.organizations.currentOrgId
  return {
    routeProps: ownProps,
    orgId,
    filters: state.trips.filters,
    isFetching: state.trips.isFetching,
    summaryFilters: state.trips.summaryFilters,
    summaryResults: state.trips.summaryResults,
    // this var use to check any driver update in trip...
    updateDriverToggle: state.trips.updateDriverToggle,
    organizations: orgId ? state.organizations.items[orgId] : null
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getTripsSummaryRequest: () => dispatch(actionCreators.getTripsSummaryRequest()),
    fetchTrips: (params: ITripSummaryFiltersDTO) => dispatch(getTripsSummary(params)),
    updateTripFilters: (params: ITripSummaryFiltersDTO) => dispatch(actionCreators.updateTripSummaryFilters(params)),
    selectTripRows: (rows: ITripState) => dispatch(actionCreators.selectTripRows(rows))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProviderTripsTable)



// WEBPACK FOOTER //
// ./src/containers/trips/ProviderTripsTable.ts